module.exports = __webpack_public_path__ + "static/media/22ESCWA7.9d623df6.jpg";